import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function AuthSuccess({ onLogin }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');

    if (token && userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        
        // Store token
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        // Call onLogin
        if (onLogin) {
          onLogin(user);
        }
        
        // Navigate to dashboard (will be handled by your existing logic)
        navigate('/dashboard');
      } catch (error) {
        console.error('Error processing OAuth login:', error);
        navigate('/login?error=oauth_failed');
      }
    } else {
      navigate('/login?error=oauth_failed');
    }
  }, [searchParams, onLogin, navigate]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{
        fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        background: '#0A0A0A'
      }}
    >
      <div className="text-white text-lg">Processing OAuth login...</div>
    </div>
  );
}

export default AuthSuccess;